import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const updateFastShippingCopyMeganavSMSelector = createSelector(
    testTargetOffersSelector,
    offers => offers.updateFastShippingCopyMeganavSM || Empty.Object
);

export { updateFastShippingCopyMeganavSMSelector };
